import Api from "./api";
import {
    COD_APPLICATION,
    TEMPLATE_FILE_UPLOAD,
    TEMPLATE_TYPE,
} from "../constants/payroll-file";

export class PayrollFileApi {
    static URL = "ms-sp-obtiene-archivos-pga/soporte-ti/v1";

    static URL_UPLOAD = "ms-sp-guarda-archivos-pga/soporte-ti/v1";

    static downloadPayrollFileApi = () =>
        Api.post(`${PayrollFileApi.URL}/get-file`, {
            entity: {
                key: "plantilla-vida-ley.xls",
                type: TEMPLATE_TYPE,
                codigoaplicacion: COD_APPLICATION,
            },
        });

    static uploadPayrollFileApi = ({
        fileName,
        fileContent,
    }: {
        fileName: string;
        fileContent: string;
    }) =>
        Api.post(`${PayrollFileApi.URL_UPLOAD}/file-save`, {
            entity: {
                templateType: TEMPLATE_FILE_UPLOAD,
                fileName,
                encodeByte: fileContent,
                codigoaplicacion: COD_APPLICATION,
            },
            customHeader: {
                ...Api.getPrivateHeader(),
                Accept: "application/stream+json",
            },
        });

    static getPayrollFileProcess = ({ fileName }: { fileName: string }) =>
        Api.post(
            `ms-ne-procesa-planillas-vida-ley-empleados-vda/cotizacion/vida-ley-empleados/v1/fileProcess/getProcess`,
            {
                entity: {
                    template: {
                        key: fileName,
                        type: TEMPLATE_FILE_UPLOAD,
                        codigoaplicacion: COD_APPLICATION,
                    },
                    movementType: "EMISION",
                },
            }
        );
}
